import _defineProperty from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _get from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _typeof from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Struct, U8aFixed } from '@polkadot/types-codec';
import { isHex, isObject, isU8a, objectSpread, u8aToU8a } from '@polkadot/util';
/**
 * Get a mapping of `argument name -> argument type` for the function, from
 * its metadata.
 *
 * @param meta - The function metadata used to get the definition.
 * @internal
 */

function getArgsDef(registry, meta) {
  return meta.fields.reduce(function (result, _ref, index) {
    var name = _ref.name,
        type = _ref.type;
    result[name.unwrapOr("param".concat(index)).toString()] = registry.createLookupType(type);
    return result;
  }, {});
}
/** @internal */


function decodeCallViaObject(registry, value, _meta) {
  // we only pass args/methodsIndex out
  var args = value.args,
      callIndex = value.callIndex; // Get the correct lookupIndex
  // eslint-disable-next-line @typescript-eslint/no-use-before-define

  var lookupIndex = callIndex instanceof GenericCallIndex ? callIndex.toU8a() : callIndex; // Find metadata with callIndex

  var meta = _meta || registry.findMetaCall(lookupIndex).meta;

  return {
    args: args,
    argsDef: getArgsDef(registry, meta),
    callIndex: callIndex,
    meta: meta
  };
}
/** @internal */


function decodeCallViaU8a(registry, value, _meta) {
  // We need 2 bytes for the callIndex
  var callIndex = registry.firstCallIndex.slice();
  callIndex.set(value.subarray(0, 2), 0); // Find metadata with callIndex

  var meta = _meta || registry.findMetaCall(callIndex).meta;

  return {
    args: value.subarray(2),
    argsDef: getArgsDef(registry, meta),
    callIndex: callIndex,
    meta: meta
  };
}
/**
 * Decode input to pass into constructor.
 *
 * @param value - Value to decode, one of:
 * - hex
 * - Uint8Array
 * - {@see DecodeMethodInput}
 * @param _meta - Metadata to use, so that `injectMethods` lookup is not
 * necessary.
 * @internal
 */


function decodeCall(registry) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Uint8Array();

  var _meta = arguments.length > 2 ? arguments[2] : undefined;

  if (isU8a(value) || isHex(value)) {
    return decodeCallViaU8a(registry, u8aToU8a(value), _meta);
  } else if (isObject(value) && value.callIndex && value.args) {
    return decodeCallViaObject(registry, value, _meta);
  }

  throw new Error("Call: Cannot decode value '".concat(value, "' of type ").concat(_typeof(value)));
}
/**
 * @name GenericCallIndex
 * @description
 * A wrapper around the `[sectionIndex, methodIndex]` value that uniquely identifies a method
 */


export var GenericCallIndex = /*#__PURE__*/function (_U8aFixed) {
  _inherits(GenericCallIndex, _U8aFixed);

  var _super = _createSuper(GenericCallIndex);

  function GenericCallIndex(registry, value) {
    _classCallCheck(this, GenericCallIndex);

    return _super.call(this, registry, value, 16);
  }

  return _createClass(GenericCallIndex);
}(U8aFixed);
/**
 * @name GenericCall
 * @description
 * Extrinsic function descriptor
 */

export var GenericCall = /*#__PURE__*/function (_Struct) {
  _inherits(GenericCall, _Struct);

  var _super2 = _createSuper(GenericCall);

  function GenericCall(registry, value, meta) {
    var _this;

    _classCallCheck(this, GenericCall);

    var decoded = decodeCall(registry, value, meta);

    try {
      _this = _super2.call(this, registry, {
        callIndex: GenericCallIndex,
        // eslint-disable-next-line sort-keys
        args: Struct.with(decoded.argsDef)
      }, decoded);
    } catch (error) {
      var method = 'unknown.unknown';

      try {
        var c = registry.findMetaCall(decoded.callIndex);
        method = "".concat(c.section, ".").concat(c.method);
      } catch (error) {// ignore
      }

      throw new Error("Call: failed decoding ".concat(method, ":: ").concat(error.message));
    }

    _this._meta = decoded.meta;
    return _this;
  }
  /**
   * @description The arguments for the function call
   */


  _createClass(GenericCall, [{
    key: "args",
    get: function get() {
      return _toConsumableArray(this.getT('args').values());
    }
    /**
     * @description The argument definitions
     */

  }, {
    key: "argsDef",
    get: function get() {
      return getArgsDef(this.registry, this.meta);
    }
    /**
     * @description The argument entries
     */

  }, {
    key: "argsEntries",
    get: function get() {
      return _toConsumableArray(this.getT('args').entries());
    }
    /**
     * @description The encoded `[sectionIndex, methodIndex]` identifier
     */

  }, {
    key: "callIndex",
    get: function get() {
      return this.getT('callIndex').toU8a();
    }
    /**
     * @description The encoded data
     */

  }, {
    key: "data",
    get: function get() {
      return this.getT('args').toU8a();
    }
    /**
     * @description The [[FunctionMetadata]]
     */

  }, {
    key: "meta",
    get: function get() {
      return this._meta;
    }
    /**
     * @description Returns the name of the method
     */

  }, {
    key: "method",
    get: function get() {
      return this.registry.findMetaCall(this.callIndex).method;
    }
  }, {
    key: "registry",
    get: function get() {
      return _get(_getPrototypeOf(GenericCall.prototype), "registry", this);
    }
    /**
     * @description Returns the module containing the method
     */

  }, {
    key: "section",
    get: function get() {
      return this.registry.findMetaCall(this.callIndex).section;
    }
    /**
     * @description Checks if the source matches this in type
     */

  }, {
    key: "is",
    value: function is(other) {
      return other.callIndex[0] === this.callIndex[0] && other.callIndex[1] === this.callIndex[1];
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman(isExpanded) {
      var _call, _call2;

      var call;

      try {
        call = this.registry.findMetaCall(this.callIndex);
      } catch (error) {// swallow
      }

      return objectSpread({
        args: this.argsEntries.reduce(function (args, _ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              n = _ref3[0],
              a = _ref3[1];

          return objectSpread(args, _defineProperty({}, n, a.toHuman(isExpanded)));
        }, {}),
        method: (_call = call) === null || _call === void 0 ? void 0 : _call.method,
        section: (_call2 = call) === null || _call2 === void 0 ? void 0 : _call2.section
      }, isExpanded && call ? {
        docs: call.meta.docs.map(function (d) {
          return d.toString();
        })
      } : null);
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return 'Call';
    }
  }]);

  return GenericCall;
}(Struct);